<div [formGroup]="form">
	<nz-form-item *ngIf="inline == false">
		<nz-form-label *ngIf="span != 0" [nzSpan]="span" [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>
		<nz-form-label *ngIf="span == 0" [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>

		<nz-form-control  [nzAutoTips]="wrapper.autoTips">
			<nz-date-picker [formControlName]="toControlKey(wrapper.element)" nzFormat="yyyy-MM-dd" [nzDisabled]="readonly">
			</nz-date-picker>
		</nz-form-control>
	</nz-form-item>
	<nz-form-item *ngIf="inline == true">
		<nz-form-control [nzAutoTips]="wrapper.autoTips">
			<nz-date-picker [formControlName]="toControlKey(wrapper.element)" nzFormat="yyyy-MM-dd"  [nzDisabled]="readonly">
			</nz-date-picker>
		</nz-form-control>
	</nz-form-item>
</div>
